import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d930770"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-[22px] h-[22px] flex items-center" }
const _hoisted_2 = { class: "agent-name--content ml-1 w-full" }
const _hoisted_3 = { class: "first-row" }
const _hoisted_4 = {
  class: "agent-name--status",
  style: {"margin-top":"4px"}
}
const _hoisted_5 = ["agent-status-value"]
const _hoisted_6 = {
  key: 0,
  class: "incredicon-solid-windows !text-[16px]"
}
const _hoisted_7 = {
  key: 1,
  class: "uil uil-linux !text-[16px]"
}
const _hoisted_8 = {
  key: 0,
  class: "font-gordita-medium text-[13px]"
}
const _hoisted_9 = { class: "flex flex-nowrap" }
const _hoisted_10 = {
  key: 0,
  class: "incredicon-build-cache !mr-0"
}
const _hoisted_11 = {
  key: 2,
  "data-cy-icon": "initiator-icon",
  class: "uil uil-clock !mr-1"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "gordita-500-10-m" }, "Initiator", -1))
const _hoisted_13 = {
  key: 0,
  class: "incredicon-build-cache !mr-0"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "gordita-500-10-m" }, "CI Initiator", -1))
const _hoisted_15 = {
  key: 1,
  "data-cy-icon": "initiator-icon",
  class: "uil uil-clock !mr-1"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "gordita-500-10-m" }, "Helper", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "gordita-500-10-m" }, "Local", -1))
const _hoisted_18 = { class: "second-row" }
const _hoisted_19 = { class: "build-title ibf-text-list3 buildingTitleBlock" }
const _hoisted_20 = {
  class: "helperCores",
  style: {"font-weight":"bold"}
}
const _hoisted_21 = {
  key: 2,
  ref: "build-title-el",
  class: "build-title ibf-text-list3 buildingTitleBlock"
}
const _hoisted_22 = { "data-testid": "build-running-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_agent_messages_tooltip = _resolveComponent("agent-messages-tooltip")!
  const _component_agent_status_legend = _resolveComponent("agent-status-legend")!
  const _component_IncrediTooltip = _resolveComponent("IncrediTooltip")!
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_tooltip_with_show_more_option = _resolveComponent("tooltip-with-show-more-option")!

  return (_openBlock(), _createElementBlock("div", {
    class: "flex flex-col gap-[36px] justify-center w-full agent-name-wrapper",
    style: _normalizeStyle(_ctx.agentRowStyle)
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.getStatusIconName || _ctx.isUpdatingAgent)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["ml-3 w-[22px] h-[22px]", { 'infinite-spinner-animation rounded-[50%] border-2 border-solid border-[#2dade4] border-b-transparent ml-[15px] !w-[16px] !h-[16px]': _ctx.isUpdatingAgent }])
          }, [
            _createElementVNode("i", {
              "data-testid": "agent-message-icon",
              tabindex: "0",
              class: _normalizeClass(["duplicateIncompatibleIcons", _ctx.getStatusIconName])
            }, [
              _createVNode(_component_agent_messages_tooltip, {
                "data-testid": `agent-message-tooltip-content-${_ctx.agentData.name}`,
                messages: { messages: _ctx.agentData.warnings !== '' ? _ctx.agentData.warnings?.split(',') : null, errors: _ctx.agentData.errors !== '' ? _ctx.agentData.errors?.split(',') : null }
              }, null, 8, ["data-testid", "messages"])
            ], 2)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: "agent-name-column",
      style: _normalizeStyle(_ctx.agentRowStyle)
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_IncrediTooltip, {
              modelValue: _ctx.showStatusTooltip,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showStatusTooltip) = $event)),
              style: {"margin-top":"-4px"},
              hover: ""
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_ctx.agentStatus), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "agent-name--status-legend",
                  "agent-status-value": _ctx.agentStatus
                }, [
                  _createVNode(_component_agent_status_legend, {
                    value: _ctx.agentStatus as any
                  }, null, 8, ["value"])
                ], 8, _hoisted_5)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          (_ctx.isSCL)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass([_ctx.agentData?.metadata?.isOffline ? 'text-Text/text_lowest' : 'text-Text/text_medium', "ml-[4px]"])
              }, [
                (_ctx.agentData?.metadata?.isWindowsAgent)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_6))
                  : (_ctx.agentData?.osVersion)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_7))
                    : _createCommentVNode("", true)
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            style: _normalizeStyle(_ctx.agentRowStyle),
            class: _normalizeClass([_ctx.agentNameClass, "agent-name--name"])
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(_ctx.isSCL ? 'ml-[4px]' : 'ml-[8px]'),
              "data-testid": "agent-cell-name"
            }, [
              (_ctx.osService?.isWindows.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.agentData.name), 1))
                : (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: _normalizeClass([{ 'hoverable-agent-name': !_ctx.isAgentCloud() }, "font-gordita-medium text-[13px]"]),
                    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openAgentSettings && _ctx.openAgentSettings(...args)), ["prevent"]))
                  }, _toDisplayString(_ctx.agentData.name), 3))
            ], 2)
          ], 6),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", null, [
              (_ctx.agentData.metadata?.isInitiator)
                ? (_openBlock(), _createBlock(_component_q_chip, {
                    key: 0,
                    class: _normalizeClass(["chip-initiator chip-chip ibf-h8 flex !px-2", _ctx.initiatorClasses]),
                    style: _normalizeStyle(_ctx.chipStyle),
                    "data-cy-initiator-chip": _ctx.agentData.metadata?.isInitiator,
                    "data-cy-suvm-chip": _ctx.isSUVM,
                    "data-cy-initiator-build-avoidance-chip": _ctx.agentData.license?.buildCacheAllowed,
                    "data-cy-initiator-initiator-queued-chip": _ctx.agentData.license?.initiatorQueued,
                    "data-cy-initiator-floating-chip": _ctx.fixedOrFloatInitiatorIcon === 'incredicon-floating',
                    "data-cy-initiator-fixed-chip": _ctx.fixedOrFloatInitiatorIcon === 'icon-Fixed',
                    "data-cy-chip-agent-name": _ctx.agentData.name
                  }, {
                    default: _withCtx(() => [
                      (_ctx.agentData.license?.buildCacheAllowed)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_10))
                        : _createCommentVNode("", true),
                      (_ctx.fixedOrFloatInitiatorIcon)
                        ? (_openBlock(), _createElementBlock("i", {
                            key: 1,
                            "data-cy-icon": "initiator-icon",
                            class: _normalizeClass([_ctx.fixedOrFloatInitiatorIcon, "!mr-1"])
                          }, null, 2))
                        : _createCommentVNode("", true),
                      (_ctx.isSUVM)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_11))
                        : _createCommentVNode("", true),
                      _hoisted_12
                    ]),
                    _: 1
                  }, 8, ["class", "style", "data-cy-initiator-chip", "data-cy-suvm-chip", "data-cy-initiator-build-avoidance-chip", "data-cy-initiator-initiator-queued-chip", "data-cy-initiator-floating-chip", "data-cy-initiator-fixed-chip", "data-cy-chip-agent-name"]))
                : _createCommentVNode("", true),
              _createVNode(_component_q_tooltip, {
                "content-class": "tooltip-background",
                anchor: "top left",
                self: "center left",
                offset: [5, 15]
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.initiatorLicenseTooltip), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", null, [
              (_ctx.agentData.metadata?.isCIInitiator)
                ? (_openBlock(), _createBlock(_component_q_chip, {
                    key: 0,
                    class: _normalizeClass(["chip-ci-initiator chip-chip flex !px-2", _ctx.initiatorClasses]),
                    style: _normalizeStyle(_ctx.chipStyle),
                    "data-cy-initiator-initiator-queued-chip": _ctx.agentData.license?.initiatorQueued,
                    "data-cy-ci-initiator-chip": _ctx.agentData.metadata?.isCIInitiator,
                    "data-cy-ci-initiator-build-avoidance-chip": _ctx.agentData.license?.buildCacheAllowed,
                    "data-cy-ci-initiator-floating-chip": _ctx.fixedOrFloatInitiatorIcon === 'incredicon-floating',
                    "data-cy-ci-initiator-fixed-chip": _ctx.fixedOrFloatInitiatorIcon === 'icon-Fixed',
                    "data-cy-chip-agent-name": _ctx.agentData.name
                  }, {
                    default: _withCtx(() => [
                      (_ctx.agentData.license?.buildCacheAllowed)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_13))
                        : _createCommentVNode("", true),
                      _createElementVNode("i", {
                        "data-cy-icon": "ci-initiator-icon",
                        class: _normalizeClass([_ctx.fixedOrFloatInitiatorIcon, "!mr-1"])
                      }, null, 2),
                      _hoisted_14
                    ]),
                    _: 1
                  }, 8, ["class", "style", "data-cy-initiator-initiator-queued-chip", "data-cy-ci-initiator-chip", "data-cy-ci-initiator-build-avoidance-chip", "data-cy-ci-initiator-floating-chip", "data-cy-ci-initiator-fixed-chip", "data-cy-chip-agent-name"]))
                : _createCommentVNode("", true),
              _createVNode(_component_q_tooltip, {
                "content-class": "tooltip-background",
                anchor: "top left",
                self: "center left",
                offset: [5, 15]
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.initiatorLicenseTooltip), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", null, [
              (_ctx.agentData.metadata?.isHelper)
                ? (_openBlock(), _createBlock(_component_q_chip, {
                    key: 0,
                    "data-cy-helper-chip": _ctx.agentData.metadata?.isHelper,
                    "data-cy-helper-cloud-chip": _ctx.helperIconComputed === 'icon-cloud',
                    "data-cy-helper-fixed-chip": _ctx.helperIconComputed === 'icon-Fixed',
                    "data-cy-helper-floating-chip": _ctx.helperIconComputed === 'incredicon-floating',
                    "data-cy-chip-agent-name": _ctx.agentData.name,
                    style: _normalizeStyle(_ctx.chipStyle),
                    class: _normalizeClass(["chip-helper chip-chip ibf-h8 flex", _ctx.helperClasses])
                  }, {
                    default: _withCtx(() => [
                      (_ctx.helperIconComputed)
                        ? (_openBlock(), _createElementBlock("i", {
                            key: 0,
                            class: _normalizeClass([_ctx.helperIconComputed, "!mr-1"])
                          }, null, 2))
                        : _createCommentVNode("", true),
                      (_ctx.isSUVM)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_15))
                        : _createCommentVNode("", true),
                      _hoisted_16
                    ]),
                    _: 1
                  }, 8, ["data-cy-helper-chip", "data-cy-helper-cloud-chip", "data-cy-helper-fixed-chip", "data-cy-helper-floating-chip", "data-cy-chip-agent-name", "style", "class"]))
                : _createCommentVNode("", true),
              _createVNode(_component_q_tooltip, {
                "content-class": "tooltip-background",
                anchor: "top left",
                self: "center left",
                offset: [5, 15]
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.helperLicenseTooltip), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", null, [
              (_ctx.agentData.metadata?.isLocal)
                ? (_openBlock(), _createBlock(_component_q_chip, {
                    key: 0,
                    "data-cy-local-chip": _ctx.agentData.metadata?.isLocal,
                    "data-cy-chip-agent-name": _ctx.agentData.name,
                    style: _normalizeStyle(_ctx.chipStyle),
                    class: _normalizeClass(["chip-local chip-chip ibf-h7 flex", { duplicate: _ctx.agentData.metadata?.isDuplicateLicense, offline: _ctx.agentData.metadata?.isOffline }])
                  }, {
                    default: _withCtx(() => [
                      _hoisted_17
                    ]),
                    _: 1
                  }, 8, ["data-cy-local-chip", "data-cy-chip-agent-name", "style", "class"]))
                : _createCommentVNode("", true),
              _createVNode(_component_q_tooltip, {
                "content-class": "tooltip-background",
                anchor: "top left",
                self: "center left",
                offset: [5, 15]
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.localLicenseTooltip), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          (_ctx.agentData.metadata?.isInitiator && _ctx.isAgentInitiating && _ctx.getNumOfRunningBuilds === 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                style: _normalizeStyle(_ctx.agentRowStyle),
                class: "helperDetails ibf-text-list3",
                "data-testid": "build-running-text"
              }, [
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('agentsTable.runningBuildNoTitle')), 1)
              ], 4))
            : _createCommentVNode("", true),
          (_ctx.isAgentHelping && (_ctx.agentData.coresUsed || 0) > 0 && _ctx.getNumOfRunningBuilds === 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                style: _normalizeStyle(_ctx.agentRowStyle),
                class: "helperDetails ibf-text-list3",
                "data-testid": "build-helping-cores-text"
              }, [
                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.agentData.coresUsed || 0) + "/" + _toDisplayString(_ctx.getCoresCount), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('agentsTable.coresHelping')) + " ", 1),
                _createElementVNode("span", null, [
                  _createElementVNode("span", {
                    style: _normalizeStyle(_ctx.getNumOfHelpedAgents === 1 ? 'font-weight: bold' : ''),
                    class: _normalizeClass(_ctx.getNumOfHelpedAgents > 1 ? 'agentDetails' : ''),
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickHandler && _ctx.clickHandler(...args)))
                  }, _toDisplayString(_ctx.getHelperCoresText), 7),
                  (_ctx.getNumOfHelpedAgents > 1 || _ctx.isOverFlow)
                    ? (_openBlock(), _createBlock(_component_tooltip_with_show_more_option, {
                        key: 0,
                        value: _ctx.showTooltip,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showTooltip) = $event)),
                        "max-items-to-display": _ctx.maxItems,
                        "items-list": _ctx.agentData.workingFor?.split(',')
                      }, null, 8, ["value", "max-items-to-display", "items-list"]))
                    : _createCommentVNode("", true)
                ])
              ], 4))
            : _createCommentVNode("", true),
          (_ctx.getNumOfRunningBuilds > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("span", _hoisted_22, [
                  _createTextVNode(_toDisplayString(_ctx.t('agentsTable.running')) + " ", 1),
                  _createElementVNode("span", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(_ctx.getNumOfRunningBuilds > 1 ? 'agentDetails' : ''),
                      "data-testid": "agent-running-build-title",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clickHandler && _ctx.clickHandler(...args)))
                    }, _toDisplayString(_ctx.getNumOfBuildsText), 3),
                    (_ctx.getNumOfRunningBuilds > 1 || _ctx.isOverFlow)
                      ? (_openBlock(), _createBlock(_component_tooltip_with_show_more_option, {
                          key: 0,
                          value: _ctx.showTooltip,
                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showTooltip) = $event)),
                          class: "agentBuildTooltip",
                          "max-items-to-display": _ctx.maxItems,
                          "items-list": _ctx.agentData.runningBuildsTitles || []
                        }, null, 8, ["value", "max-items-to-display", "items-list"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 512))
            : _createCommentVNode("", true)
        ])
      ])
    ], 4)
  ], 4))
}